<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import God from './views/god'

/**
 * 屏幕适配方案 - 基于 CSS Zoom/Transform
 * 设计稿尺寸: 1920px 宽度
 * 适配策略: 宽度自适应，高度自动，保持横向比例
 */
export default {
  name: 'app',
  data() {
    return {
      // 设计稿宽度
      designWidth: 1920,
      // 当前缩放比例
      scale: 1,
      // resize 防抖定时器
      resizeTimer: null
    }
  },
  created() {
    // 非移动端初始化 God
    if (!this.isMobile()) {
      new God().init()
    }
  },
  mounted() {
    // 初始化适配
    this.initScale()

    // 监听窗口变化
    window.addEventListener('resize', this.onResize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize)
  },
  methods: {
    /**
     * 判断是否为移动端
     */
    isMobile() {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
    },

    /**
     * 初始化缩放
     */
    initScale() {
      if (this.isMobile()) {
        // 移动端不缩放
        document.body.style.zoom = 1
        return
      }

      this.updateScale()
    },

    /**
     * 更新缩放比例
     */
    updateScale() {
      const screenWidth = window.innerWidth
      // 计算缩放比例：屏幕宽度 / 设计稿宽度
      this.scale = screenWidth / this.designWidth

      // 应用缩放
      document.body.style.zoom = this.scale

      // 同时设置 transform 作为后备方案（某些浏览器 zoom 不支持）
      // document.body.style.transform = `scale(${this.scale})`
      // document.body.style.transformOrigin = 'top left'
    },

    /**
     * 窗口大小变化处理
     * 使用 requestAnimationFrame 替代 setTimeout，消除滞后感
     */
    onResize() {
      if (this.isMobile()) return

      // 取消之前的定时器
      if (this.resizeTimer) {
        cancelAnimationFrame(this.resizeTimer)
      }

      // 使用 requestAnimationFrame 实现流畅的更新
      this.resizeTimer = requestAnimationFrame(() => {
        this.updateScale()
      })
    }
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html,
body {
  width: 100%;
  min-height: 100vh;
  /* 允许内容滚动 */
  overflow-x: hidden;
  overflow-y: auto;
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  width: 1920px;
  /* 高度由内容决定 */
  min-height: 100vh;
  margin: 0 auto;
  position: relative;
}

/* 移动端适配：宽度100%，不缩放 */
@media screen and (max-width: 768px) {
  #app {
    width: 100%;
    zoom: 1 !important;
    transform: none !important;
  }
}
</style>
